/**
 * The key that makes a retried money request replay instead of repeat.
 *
 * **It is minted when the confirm dialog opens, not when the request is sent.** That is the whole
 * point: a double-click, a dropped connection or a user reaching for the button again all send
 * the *same* key, so the server returns the first answer rather than building a second payout
 * batch. A key generated inside the mutation would be new on every attempt and would protect
 * nothing.
 *
 * Mutations are never retried automatically (`queryClient.ts`), so the only retries are human
 * ones — which is exactly what this covers.
 */

/** A UUIDv4. Exported separately so a test can pin the header shape without stubbing crypto. */
export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}

export function idempotent(key: string): Record<string, string> {
  return { 'Idempotency-Key': key };
}
